import Model from '@/class/cargo/model/utils/Model'

/**
 * ExternalFileType 常外部文件类型
 */
export class ExternalFileType {
  constructor(code, type, chineseName, englishName, path) {
    this.code = code
    this.type = type
    this.chineseName = chineseName
    this.englishName = englishName
    this.path = path
  }
}

export const CODE_NAME = 'ExternalFileType'

// // 欧坚code 待提供
// export const EXTERNAL_FILE_OJ = new ExternalFileType('0', 1, '欧坚报关', 'Ojian customs', '0')
// export const EXTERNAL_FILE_OJ_1 = new ExternalFileType('1', 2, '放行通知书', 'Release notice', '0,1')
// export const EXTERNAL_FILE_OJ_2 = new ExternalFileType('2', 2, '报关单', 'manifest', '0,2')
// export const EXTERNAL_FILE_OJ_3 = new ExternalFileType('3', 2, '报关委托书', 'customs power of attorne', '0,3')

// 信号旗报关 path表示层级结果。例：（1,2），1表示父级路径，为父级的code;2表示当前路径,可随意定义，不重复即可
export const XHQ_CUSTOMS = new ExternalFileType('1', 1, '信号旗报关', 'XHQ Customs', '1')
export const CUSTOMS_RELEASE_NOTICE = new ExternalFileType('CUSTOMS RELEASE NOTICE', 2, '放行通知书', 'Release notice', '1,1')
export const CUSTOMS_PROXY = new ExternalFileType('CUSTOMS PROXY', 2, '报关委托书', 'Customs Proxy', '1,2')
export const CUSTOMS_INSPECTION_NOTICE = new ExternalFileType('CUSTOMS INSPECTION NOTICE', 2, '查验通知书', 'Customs Inspection Notice', '1,3')
export const CUSTOMS_INSPECTION_DRAFT = new ExternalFileType('CUSTOMS INSPECTION DRAFT', 2, '校验稿', 'Customs Inspection Draft', '1,4')
export const CUSTOM_DECLARATION_NOTE = new ExternalFileType('customDeclarationNote', 2, '报关单', 'Custom Declaration Note', '1,5')
export const LCL_CUSTOMS_DECLARATION_LIST = new ExternalFileType('LCL CUSTOMS DECLARATION LIST', 2, '拼箱报关清单', 'LCL Customs Declaration List', '1,6')
// 信号旗单证中心
export const XHQ_DOC_CENTER = new ExternalFileType('2', 1, '信号旗单证中心', 'Signal flag document center', '2')
export const XHQ_CONFIRMATION_OF_BILL_OF_LADING = new ExternalFileType('CONFIRMATION OF BILL OF LADING', 2, '提单确认件', 'Confirmation of bill of lading', '2,1')
export const XHQ_CUSTOMER_SELF_RELEASE = new ExternalFileType('CUSTOMERSELFRELEASE', 2, '客户自出单', 'Customer self release', '2,2')
export const XHQ_RELEASE_BILL_OF_LADING = new ExternalFileType('RELEASE BILL OF LADING', 2, '电放提单', 'Release bill of lading', '2,3')
export const XHQ_ORIGINAL_BILL_OF_LADING = new ExternalFileType('ORIGINAL BILL OF LADING', 2, '正本提单', 'original bill of lading', '2,4')
export const XHQ_SHIPPING_ORDER = new ExternalFileType('SHIPPING_ORDER', 2, '托书文件', 'Shipping Order', '2,5')

// 电子发票
export const INVOICE_DOC_TYPE = new ExternalFileType('3', 1, '电子发票', 'Electronic Invoice', '3')
export const INVOICE_BW_DOC_TYPE = new ExternalFileType('INVOICE BW ALL ELECTRONIC', 2, '百旺全电', 'Bai Wang All Electronic Invoice', '3,1')
export const INVOICE_RJ_DOC_TYPE = new ExternalFileType('INVOICE RJ ALL ELECTRONIC', 2, '容津全电', 'Rong Jin All Electronic Invoice', '3,2')
export const INVOICE_LL_DOC_TYPE = new ExternalFileType('INVOICE LL ALL ELECTRONIC', 2, '诺诺全电', 'Luo Luo All Electronic Invoice', '3,3')

export const RELEASE_BILL_GUARANTEE = new ExternalFileType('4', 1, '放单管理上传保函', 'Release Bill Guarantee', '4')
export const HBL_SINGLE_TICKET_GUARANTEE = new ExternalFileType('HBL SINGLE TICKET GUARANTEE', 2, 'HBL单票保函', 'Hbl Single Ticket Guarantee', '4,1')

// 美华报关
export const MEIHUA_CUSTOM = new ExternalFileType('5', 1, '美华报关', 'Mei Hua Customs', '5')
export const MEIHUA_RELEASE_NOTICE = new ExternalFileType('releaseNotice', 2, '放行通知书', 'Release Notice', '5,1')
export const MEIHUA_CUSTOMS_DECLARATION = new ExternalFileType('customsDeclaration', 2, '报关单', 'Customs Declaration', '5,2')
export const MEIHUA_AUTHORIZATION_LETTER = new ExternalFileType('authorizationLetter', 2, '报关委托书', 'Power Of Attorney', '5,3')
export const MEIHUA_EXAMINE_PDF = new ExternalFileType('examinePdf', 2, '查验通知书', 'Inspection Notice', '5,4')
export const MEIHUA_ALLOW_LIFTING = new ExternalFileType('allowLifting', 2, '准予提离通知书', 'Permission To Withdraw Notice', '5,5')

// 美华报关
export const MEIHUA_CUSTOMS = [
  MEIHUA_CUSTOM,
  MEIHUA_RELEASE_NOTICE,
  MEIHUA_CUSTOMS_DECLARATION,
  MEIHUA_AUTHORIZATION_LETTER,
  MEIHUA_EXAMINE_PDF,
  MEIHUA_ALLOW_LIFTING
]

export const INVOICE_DOC_TYPE_FILE = [
  INVOICE_DOC_TYPE,
  INVOICE_BW_DOC_TYPE,
  INVOICE_RJ_DOC_TYPE,
  INVOICE_LL_DOC_TYPE
]

export const XHQ_DOC_CENTER_FILE = [
  XHQ_DOC_CENTER,
  XHQ_CONFIRMATION_OF_BILL_OF_LADING,
  XHQ_CUSTOMER_SELF_RELEASE,
  XHQ_RELEASE_BILL_OF_LADING,
  XHQ_ORIGINAL_BILL_OF_LADING,
  XHQ_SHIPPING_ORDER
]

export const RELEASE_BILL_GUARANTEE_FILE = [
  RELEASE_BILL_GUARANTEE,
  HBL_SINGLE_TICKET_GUARANTEE
]

// export const EXTERNAL_FILE_TYPES_OJ = [
//   EXTERNAL_FILE_OJ,
//   EXTERNAL_FILE_OJ_1,
//   EXTERNAL_FILE_OJ_2,
//   EXTERNAL_FILE_OJ_3
// ]

export const EXTERNAL_FILE_TYPES_XHQ = [
  XHQ_CUSTOMS,
  CUSTOMS_RELEASE_NOTICE,
  CUSTOMS_PROXY,
  CUSTOMS_INSPECTION_NOTICE,
  CUSTOMS_INSPECTION_DRAFT,
  CUSTOM_DECLARATION_NOTE,
  LCL_CUSTOMS_DECLARATION_LIST
]

/**
 * 取上级
 * @param dataList
 * @param code
 * @returns {*}
 */
export function getPath(dataList, code) {
  const file = dataList.find(p => p.code === code)
  if (file && file.path) {
    return file.path.split(',')[0]
  }
  return code
}

/**
 *  return null:没找到.
 */
export function getExternalFile(code) {
  let data = Model.getObjByCode(code, XHQ_DOC_CENTER_FILE)
  if (!data) {
    data = Model.getObjByCode(code, EXTERNAL_FILE_TYPES_XHQ)
  }
  if (!data) {
    data = Model.getObjByCode(code, INVOICE_DOC_TYPE_FILE)
  }
  if (!data) {
    data = Model.getObjByCode(code, RELEASE_BILL_GUARANTEE_FILE)
  }
  return data
}

